import Grid from "@mui/material/Grid";
import {
  CmpInputField,
  CmpTypographyField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";

export default function WmsFooter({
  vRdxWmsHead,
  fTruckCBM,
  fItemCBM,
  fTotalWeignt,
  fPrintAllDocument,
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="align-items-center justify-content-around"
      >
        <Grid item xs={12} sm={12} md={3} >
          {/* <button
            className={
              vRdxWmsHead.A_DocStat === "ENTER"
                ? "btn px-3  py-0 btn-warning"
                : vRdxWmsHead.A_DocStat === "POST"
                ? "btn px-3  py-0 btn-success"
                : vRdxWmsHead.A_DocStat === "DELETE"
                ? "btn px-3  py-0 btn-danger"
                : vRdxWmsHead.A_DocStat === "DRAFT"
                ? "btn px-3  py-0 btn-secondary"
                : "btn px-3 btn-primary"
            }
            // className="hide-all-time"
          >
            <span> STATUS = </span>
            <span>{vRdxWmsHead.A_DocStat}</span>
          </button> */}
          <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
        </Grid>
       
        <Grid item xs={12} sm={12} md={1} >
          <CmpTypographyField xcomponent={"div"} xText={"Truck CBM"} />
        </Grid>
        <Grid item xs={12} sm={12} md={2} >
          <CmpInputField
            xValue={vRdxWmsHead.TruckCBM}
            xType={"text"} // text/number/password
            xName={"TruckCBM"}
            xReadOnly={true}
            xOnChange={fTruckCBM}
            xError={false}
            xErrorMessage={""}
            xTextAlign="right"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={1} >
          <CmpTypographyField xcomponent={"div"} xText={"Item CBM"} />
        </Grid>
        <Grid item xs={12} sm={12} md={1} >
          <CmpInputField
            xValue={vRdxWmsHead.ItemCBM}
            xType={"text"} // text/number/password
            xName={"ItemCBM"}
            xReadOnly={true}
            xOnChange={fItemCBM}
            xError={false}
            xErrorMessage={""}
            xTextAlign="right"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={1.5}  >
          <CmpTypographyField xcomponent={"div"} xText={"Total Weignt"} />
        </Grid>
        <Grid item xs={12} sm={12} md={1} >
          <CmpInputField
            xValue={vRdxWmsHead.TotalWeight}
            xType={"text"} // text/number/password
            xName={"TotalWeight"}
            xReadOnly={true}
            xOnChange={fTotalWeignt}
            xError={false}
            xErrorMessage={""}
            xTextAlign="right"
          />
        </Grid>
      </Grid>
    </div>
  );
}
